import { IApiContentResponseModel } from '@woonstad/api-client-content-delivery';

const getParentEntry = (items: IApiContentResponseModel[], pageRoute: string) => {
  const parentPath = pageRoute
    ?.split('/')
    ?.filter(Boolean)
    ?.toReversed()
    ?.toSpliced(0, 1)
    ?.toReversed()
    ?.join('/');

  const parentEntryName = items.find((item) => (
    item.route?.path === `/${parentPath}/`
  ))?.name;

  return parentEntryName;
};

export const getParentsList = (topPageRoute: string, items?: IApiContentResponseModel[]): string[] => {
  if (!items) {
    return [];
  }

  const pathsAbove = topPageRoute
    ?.split('/')
    ?.filter(Boolean)
    ?.map((_, index, array) => (
      `/${array.slice(0, index + 1).join('/')}/`
    ))
    ?.filter(Boolean);

  const parentNames = pathsAbove
    ?.map((path) => getParentEntry(items, path))
    ?.filter(Boolean) as string[];

  return parentNames;
};
